import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

export default function ReportTemplatesPanel() {
  const [data, setData] = useState(null);
  const [choices, setChoices] = useState({});
  const [busy, setBusy] = useState('');
  const [preview, setPreview] = useState('');
  useEffect(() => {
    let active = true;
    axios.get('/report-templates').then(({data}) => {
      if (!active) return;
      setData(data);
      setChoices(Object.fromEntries(data.schools.map(s => [s.id, s.template_id])));
    }).catch(() => toast.error('No se pudieron cargar las plantillas.'));
    return () => { active = false; };
  }, []);
  useEffect(() => () => { if (preview) URL.revokeObjectURL(preview); }, [preview]);
  const save = async school => {
    setBusy(school.id);
    try {
      await axios.put(`/report-templates/schools/${school.id}`, {template_id: choices[school.id]});
      setData(d => ({...d, schools: d.schools.map(s => s.id === school.id ? {...s, template_id: choices[s.id]} : s)}));
      toast.success('Plantilla de notas asignada.');
    } catch (e) { toast.error(e.response?.data?.detail || 'No se pudo asignar la plantilla.'); }
    finally { setBusy(''); }
  };
  const showPreview = async school => {
    setBusy(school.id);
    try {
      const {data} = await axios.get(`/report-templates/schools/${school.id}/preview`, {responseType:'blob'});
      setPreview(URL.createObjectURL(new Blob([data], {type:'application/pdf'})));
    } catch (e) { toast.error('No se pudo generar la vista previa. Verifica el logo de la escuela.'); }
    finally { setBusy(''); }
  };
  if (!data) return <p role="status">Cargando plantillas de notas…</p>;
  return <div className="space-y-5">
    <div>
      <h2 className="text-xl font-semibold text-slate-900">Plantillas de notas</h2>
      <p className="text-sm text-slate-600 mt-2">Asigna el formato que usará cada escuela al descargar una boleta. El informe toma el nombre y el logo actuales de la escuela en EduCore.</p>
      <p className="text-sm text-slate-600 mt-2">El formato de semanas presenta las notas registradas por período, las ausencias y las tardanzas del año elegido. La nota final se completa cuando hay notas en los cuatro períodos. Las firmas quedan disponibles para firmar.</p>
    </div>
    {data.schools.map(school => <Card key={school.id}>
      <CardHeader><CardTitle className="text-base">{school.name}</CardTitle></CardHeader>
      <CardContent className="space-y-3">
        <label className="block text-sm font-medium" htmlFor={`report-template-${school.id}`}>Formato de boleta</label>
        <select id={`report-template-${school.id}`} className="w-full rounded-md border border-slate-300 p-2 text-sm bg-white"
          value={choices[school.id]} onChange={e => setChoices(c => ({...c, [school.id]:e.target.value}))}>
          {data.templates.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
        </select>
        <div className="flex flex-wrap gap-2">
          <Button disabled={!!busy || choices[school.id] === school.template_id} onClick={() => save(school)}>Guardar asignación</Button>
          <Button variant="outline" disabled={!!busy} onClick={() => showPreview(school)}>Vista previa del formato de semanas</Button>
        </div>
      </CardContent>
    </Card>)}
    {preview && <Card>
      <CardHeader><CardTitle className="text-base">Vista previa con datos de ejemplo</CardTitle></CardHeader>
      <CardContent>
        <a className="text-blue-700 underline" href={preview} target="_blank" rel="noreferrer">Abrir PDF de ejemplo</a>
        <iframe title="Vista previa del informe de notas" src={preview} className="w-full h-[650px] border rounded-md mt-3" />
      </CardContent>
    </Card>}
  </div>;
}
